// api.js
import axios from "axios";
import { encryptRequest, decryptData, isEncryptionEnabled } from "./encryption";

export const fetchHandler = async (url, data) => {
    try {
        const response = await axios.post(url, data);
        return response.data.resDecrypt;
    } catch (error) {
        console.error("Error in API request:", error.message);
        throw error;
    }
};




const config = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 25000,
  headers: {
    "Content-Type": "application/json",
  },
};

// axios instance creation
export const ApiServiceLoaderless = axios.create(config);

const ApiService = axios.create(config);

// request interceptor
ApiService.interceptors.request.use(
  async (config) => {

    if (!config.headers['Disable-Loader']) {
      document.body.classList.add('loading-indicator');
    }
    
    // Extract api_key and user_id from URL and move to body
    if (config.url) {
      try {
        // Check if URL is absolute or relative
        const isAbsoluteUrl = config.url.startsWith('http://') || config.url.startsWith('https://');
        
        let urlObj;
        if (isAbsoluteUrl) {
          urlObj = new URL(config.url);
        } else {
          // For relative URLs, construct full URL for parsing
          const baseURL = config.baseURL || process.env.REACT_APP_API_BASE_URL;
          urlObj = new URL(config.url, baseURL);
        }
        
        const params = urlObj.searchParams;
        
        // Extract api_key and user_id from query params
        const apiKey = params.get('api_key');
        const userId = params.get('user_id');
        
        // If found, add them to request body and remove from URL
        if (apiKey || userId) {
          // Initialize data if not exists
          if (!config.data) {
            config.data = {};
          }
          
          // Add to body
          if (apiKey) {
            config.data.api_key = apiKey;
            params.delete('api_key');
          }
          if (userId) {
            config.data.user_id = userId;
            params.delete('user_id');
          }
          
          // Update URL without api_key and user_id
          if (isAbsoluteUrl) {
            // For absolute URLs, reconstruct the full URL
            config.url = urlObj.origin + urlObj.pathname + (params.toString() ? '?' + params.toString() : '');
          } else {
            // For relative URLs, only use the path part relative to baseURL
            const baseURL = config.baseURL || process.env.REACT_APP_API_BASE_URL;
            const basePath = new URL(baseURL).pathname;
            let relativePath = urlObj.pathname;
            
            // Remove the base path from the pathname to get the relative path
            if (relativePath.startsWith(basePath)) {
              relativePath = relativePath.substring(basePath.length);
              // Remove leading slash if present
              if (relativePath.startsWith('/')) {
                relativePath = relativePath.substring(1);
              }
            }
            
            config.url = relativePath + (params.toString() ? '?' + params.toString() : '');
          }
        }
      } catch (error) {
        console.error('URL parsing error:', error);
        // If URL parsing fails, continue with original URL
      }
    }
    
    // Encrypt request data if encryption is enabled and not disabled for this request
    if (isEncryptionEnabled() && !config.headers['Disable-Encryption'] && config.data) {
      try {
        config.data = encryptRequest(config.data);
      } catch (error) {
        console.error('Request encryption failed:', error);
      }
    }
    
    // do something before request is sent
    return config;
  },
  (error) => {
    document.body.classList.remove('loading-indicator');
    //  do something if error
    return Promise.reject(error);
  }
);

// response interceptor
ApiService.interceptors.response.use(
  async (response) => {
    document.body.classList.remove('loading-indicator');
    
    // Decrypt response data if encryption is enabled
    if (isEncryptionEnabled()) {
      try {
        // Check if response.data is a string (encrypted)
        if (typeof response.data === 'string' && response.data.length > 0) {
          const decrypted = decryptData(response.data);
          const decryptedData = JSON.parse(decrypted);
          
          // Wrap in resDecrypt format for compatibility
          response.data = {
            resDecrypt: decryptedData
          };
        }
        // If response already has resDecrypt, leave it as is
      } catch (error) {
        console.error('Response decryption failed:', error);
      }
    }
    
    // do something post getting response
    return response;
  },

  async (error) => {
    document.body.classList.remove('loading-indicator');
    // do something if some error
    return Promise.reject(error);
  }
);

export default ApiService;





// import axios from "axios";

// const config = {
//     baseURL: process.env.REACT_APP_API_BASE_URL,
//     timeout: 25000,
//     headers: {
//         "Content-Type": "application/json",
//     },
// };

// // axios instance creation
// export const KonfehtiServiceLoaderless = axios.create(config);
// const KonfehtiService = axios.create(config);

// // request interceptor
// // KonfehtiService.interceptors.request.use(
// //     async (config) => {
// //         // spinning start to show
// //         document.body.classList.add("loading-indicator");
// //         return config;
// //     },
// //     (error) => {
// //         document.body.classList.remove("loading-indicator");
// //         return Promise.reject(error);
// //     }
// // );

// // response interceptor
// // KonfehtiService.interceptors.response.use(
// //     async (response) => {
// //         // spinning hide
// //         document.body.classList.remove("loading-indicator");
// //         return response;
// //     },

// //     async (error) => {
// //         document.body.classList.remove("loading-indicator");
// //         return Promise.reject(error);
// //     }
// // );

// export default KonfehtiService;